import { ContentState, convertFromHTML, convertToRaw, RawDraftContentState } from 'draft-js';

export default (html?: string): RawDraftContentState | undefined => {
    if (typeof html !== 'string') return html;

    const blocksFromHtml = convertFromHTML(html);
    const contentState = ContentState.createFromBlockArray(blocksFromHtml.contentBlocks, blocksFromHtml.entityMap);
    return convertToRaw(contentState);
};
